import { Input as ReactUIInput, type InputProps as ReactUIInputProps } from '@tunein/react-ui';
import clsx from 'clsx';
import css from './input.module.scss';

export type InputProps = ReactUIInputProps;

/**
 * App-themed Input for gemini-web.
 * Thin wrapper around `@tunein/react-ui` Input that applies the app's light theme
 * (colors, placeholder, border states) and defaults to `size="md"` (48px).
 *
 * Use this directly for standalone inputs (controlled/uncontrolled), or compose
 * via `FormInput` for react-final-form integration.
 */
export default function Input({
  size = 'md',
  className,
  labelClassName,
  errorClassName,
  ...rest
}: InputProps) {
  return (
    <ReactUIInput
      size={size}
      className={clsx(css.input, className)}
      labelClassName={clsx(css.label, labelClassName)}
      errorClassName={clsx(css.error, errorClassName)}
      {...rest}
    />
  );
}
